/**
 * Frontend Type Definitions
 */

/**
 * Conversation Status
 */
export enum ConversationStatus {
  Draft = 'draft',
  Recording = 'recording',
  Processing = 'processing',
  Completed = 'completed',
  Failed = 'failed',
}

/**
 * Save Conversation Request
 */
export interface SaveConversationRequest {
  inwoner: string;
  datumGesprek: string;
  audioBlob: Blob;
  duration: number;
  typeGesprek: string;
  dossierId?: string;
}

/**
 * Save Conversation Response
 */
export interface SaveConversationResponse {
  success: boolean;
  conversationId?: string;
  blobPath?: string;
  blobUrl?: string;
  message?: string;
}

/**
 * User Info (from useUserInfo hook)
 */
export interface UserInfo {
  displayName: string;
  mail: string;
  userPrincipalName: string;
}